"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const native_base_1 = require("native-base");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const colors_1 = require("../../common/colors");
const useDevice_1 = require("../../hooks/useDevice");
const AppButton_1 = __importDefault(require("../AppButton"));
const AppDeleteConfirmation = (props) => {
    const { isOpen, onClose, handleDeleteAccount } = props;
    const { isTabOrDesktopDevice } = (0, useDevice_1.useDevice)();
    const activeSubscription = (0, react_redux_1.useSelector)((state) => state.subscriptionPlan.subscription);
    const fbUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.fbUser);
    // confirm delete
    const confirmDelete = (0, react_1.useCallback)(async () => {
        handleDeleteAccount();
    }, [fbUser?.uid]);
    // Cancel confirm
    const confirmDeleteCancel = (0, react_1.useCallback)(async () => {
        onClose();
    }, [fbUser?.uid]);
    const deleteAccountRef = react_1.default.useRef(null);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isOpen && ((0, jsx_runtime_1.jsx)(native_base_1.AlertDialog, { leastDestructiveRef: deleteAccountRef, isOpen: isOpen, onClose: onClose, style: {
                backgroundColor: "#7D7D8080",
                padding: 0,
                width: "100%",
            }, children: (0, jsx_runtime_1.jsxs)(native_base_1.AlertDialog.Content, { backgroundColor: colors_1.Colors.DARK_600, p: 4, borderRadius: 30, width: "80%", children: [(0, jsx_runtime_1.jsx)(native_base_1.Text, { color: colors_1.Colors.white, fontSize: 24, fontWeight: 500, textAlign: "center", width: "100%", children: activeSubscription && activeSubscription?.identifier
                            ? "Your subscription needs be cancelled"
                            : "Deactivate Account?" }), (0, jsx_runtime_1.jsx)(native_base_1.Text, { color: colors_1.Colors.DARK_200, textAlign: "center", fontSize: isTabOrDesktopDevice ? 16 : 14, width: "100%", fontWeight: 400, py: 3, px: 3, children: activeSubscription && activeSubscription?.identifier
                            ? "To deactivate your account, first you need to cancel your subscription. Are you sure you want to cancel it?"
                            : "Your account would be deactivated for 90 days and will be deleted if you don’t log back in that time. Should you choose to deactivate you will be logged out." }), (0, jsx_runtime_1.jsxs)(native_base_1.Button.Group, { space: 0, py: 3, justifyContent: "space-around", children: [(0, jsx_runtime_1.jsx)(AppButton_1.default, { variant: "ghost", colorScheme: "blue", fontSize: 16, color: colors_1.Colors.PRIMARY_200, onPress: confirmDeleteCancel, children: activeSubscription && activeSubscription?.identifier
                                    ? "Don't Cancel"
                                    : "Back" }), (0, jsx_runtime_1.jsx)(native_base_1.Button, { colorScheme: "danger", variant: "ghost", fontSize: 16, color: colors_1.Colors.FAILURE, onPress: confirmDelete, ref: deleteAccountRef, children: activeSubscription && activeSubscription?.identifier
                                    ? "Yes, Cancel "
                                    : "Deactivate" })] })] }) })) }));
};
exports.default = (0, react_1.memo)(AppDeleteConfirmation);
